import React from "react";
import CountUp from "react-countup";

interface CountUpComponentProps {
    start?: number;
    end: number;
    duration?: number;
    formattingFn?: (value: number) => string;
    admin?: boolean;
}

const CountUpComponent: React.FC<CountUpComponentProps> = ({
    start = 0,
    end,
    duration = 2.5,
    formattingFn = (value) => {
        if (value >= 1000000) {
            return (value / 1000000).toFixed(1) + "M";
        } else if (value >= 1000) {
            return (value / 1000).toFixed(1) + "k";
        } else {
            return value.toString();
        }
    },
    admin,
}) => {
    return (
        <CountUp
            start={admin ? end : start}
            end={end}
            duration={duration}
            separator=","
            decimals={0}
            decimal="."
            prefix=""
            suffix=""
            formattingFn={formattingFn}
        />
    );
};

export default CountUpComponent;
